import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export const SkucmmsEmpty = () => {
    return (
        <Stack justifyContent="center" alignItems="center" gap={2} sx={{ py: 6 }}>
            <Box
                component="img"
                src="./img/empty.svg"
                alt="Nenhum registro encontrado"
                sx={{ width: 220, maxWidth: '80%' }}
            />
            <Stack gap={0.5} alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                    Nenhum registro encontrado
                </Typography>
                <Typography variant="body2" align="center" color="text.secondary">
                    Use o filtro de Cód. SKU para carregar os itens.
                </Typography>
            </Stack>
        </Stack>
    );
};

